module.exports={
    "over_size_message":"Billedet du uploadede er over 10MB. Vi komprimerer din fil til upload. Klik venligst på \"Bekræft\" for at fortsætte med at uploade.",
    "file_type_error":"Filen du uploadede er ikke et billede! Prøv venligst at uploade igen.",
    "upload_error":"Upload fejl! (Fejlkode: 2000) Prøv venligst igen.",
    "watermark_remove_over_size":"Billedet du uploadede er over 5MB. Det anbefales, at du bruger vores gratis online billedkompressor. Klik for at <a class=\"jump-link\" href=\"https://www.anymp4.com/da/image-compressor-online/\">få mere at vide</a>",
    "watermark_remove_file_type_error":"Filen du uploadede er ikke et billede, upload venligst igen.",
    "watermark_remove_image_type_error":"Billedformatet understøttes ikke. Vi understøtter kun JPG, JPEG, PNG og BMP.",
    "watermark_remove_upload_error":"Genkendelsesfejl (fejlkode: 2001), prøv venligst igen...",
    "watermark_remove_processing":"Behandler billede...",
    "watermark_remove_not_save":"Det område, du valgte, vil ikke blive bibeholdt. Er du sikker på, at du vil beskære den?",
    "watermark_remove_back_home":"Den aktuelle status vil ikke blive gemt. Er du sikker på, at du vil tilbage til Home?",
    "watermark_remove_new_image":"Den aktuelle status vil ikke blive gemt. Er du sikker på, at du vil vælge et nyt billede?",
    "watermark_select":"Vælg",
    "watermark_select_area":"Vælg det område af vandmærket, du vil slette, før du klikker på Fjern.",
    "watermark_beyond_4k":"Det valgte billede overstiger 4K opløsning. Vi beklager, at vi ikke kan behandle det på nuværende tidspunkt",
    "watermark_beyond_pixel_1":"Den valgte billedopløsning overstiger <span>%spx</span><span>&times;%spx</span>. Den kan ikke behandles, vælg venligst igen.",
    "watermark_beyond_pixel_2":"Besøgende kan kun behandle <span>%s</span> billeder med en opløsning over <span>%spx</span>x<span>%spx</span>. Log venligst ind og fortsæt med at bruge.",
    "watermark_beyond_size_1":"Den valgte billedstørrelse overstiger <span>%sMB</span>. Den kan ikke behandles, vælg venligst igen.",
    "watermark_beyond_size_2":"Den valgte billedstørrelse overstiger <span>%sMB</span>, men besøgende kan kun behandle billeder mindre end <span>%sMB</span>. Log venligst ind og fortsæt med at bruge.",
    "no_user_down":"Besøgende kan kun downloade <span>%s</span> billeder med original kvalitet. Log venligst ind og fortsæt med at downloade. Du kan også beholde 7-dages historik efter login. Fortsæt med at downloade billeder, der er <span>%spx</span> brede eller høje.",
    "no_down_rights":"Kan ikke downloade HD-billeder med original kvalitet. Opgrader venligst din plan! Du kan også fortsætte med at downloade billeder i lav kvalitet med <span>%spx</span>.",
    "error_40001":"Fejl: 40001. Kontakt os venligst",
    "error_40099":"Fejl: 40099. Kontakt os venligst",
    "down_btn":"Download er under forberedelse, vent venligst et øjeblik...",
    "noRemove_down_btn":"Du har ikke gjort noget for at fjerne vandmærker. Vælg venligst det vandmærke, du vil fjerne, og klik på knappen Fjern. Så kan du downloade dit billede.",
    "history_open":"Åbner det ændrede billede, vent venligst et øjeblik...",
    "maskRightsMonitor_info":"Siden for opgradering af fordele er blevet åbnet i en ny fane, og din plan bliver automatisk synkroniseret efter opgradering.",
    "maskLoginMonitor_info":"Landingssiden er blevet åbnet. Udfyld venligst login på den. Efter at have logget ind eller registreret succesfuldt, vil denne side blive synkroniseret automatisk. Luk den ikke.",
    "photo_rights_info":"<span><i class=\"num\">2</i> HD-billede(r)</span> med original kvalitet kan downloades i øjeblikket. <a href=\"https://account.anymp4.com\" target=\"_blank\">Se detaljer>></a>",
    "rights_original":"For at aktivere indstillingen \"Brug Image Enhancer-funktionen til at reducere kvalitetstabet\" skal du opgradere din konto!",
    "Brush":"Børste",
    "Lasso":"Lasso",
    "Polygonal":"Polygonal",
    "Eraser":"Viskelæder",
    "Free":"Ledig",
    "More":"Mere:",
    "Select":"Vælg",
    "Remove":"Fjerne",
    "BrushSize":"Børstestørrelse:",
    "AspectRatio":"Aspektforhold:",
    "Upload":"Nyt foto",
    "History":"Historie",
    "Login":"Log på",
    "MyAccount":"Min konto",
    "Logout":"Log ud",
    "Usinghelp":"Brug af hjælp >>",
    "Enhancer":"Brug funktionen Image Enhancer til at reducere kvalitetstabet",
    "Download":"Hent",
    "Guide":"Guide",
    "Polygonal1":"Polygonal",
    "Polygonal_info":"Klik på venstre museknap for at identificere et punkt ad gangen.",
    "Lasso1":"Lasso:",
    "Lasso_info":"Tryk længe på venstre museknap for at lasso vandmærkeområdet.",
    "Brush1":"Børste:",
    "Brush_info":"Tryk længe på venstre museknap for at vælge præcist.",
    "Eraser1":"Viskelæder:",
    "Eraser_info":"Slet unødvendige dele fra det valgte område.",
    "Click":"Klik",
    "the":"det",
    "click_info":"knappen for at begynde at udslette det uønskede vandmærke.",
    "PleaseUploadImages":"Upload venligst billeder.",
    "CropInfo":"Når vandmærket er fjernet, kan du klikke på knappen Beskær for at beskære dit billede, før du gemmer, eller klikke på knappen Download for at gemme det aktuelle billede direkte.",
    "Crop":"Afgrøde",
    "Back":"Tilbage",
    "DownloadCropped":"Download beskåret",
    "Cancel":"Afbestille",
    "FreeWatermarkRemover":"Gratis fjernelse af vandmærker",
    "Processing":"Forarbejdning...",
    "NewImage":"Nyt billede",
    "Retry":"Prøve igen",
    "Yes":"Ja",
    "No":"Ingen",
    "FailureFeedback":"Fejlfeedback",
    "removeTip":"Når du har valgt vandmærkeområdet, skal du klikke på Fjern for at slette vandmærket.",
    "rightDown":"Download billeder i lav kvalitet",
    "history_will":"Udløber efter",
    "Expired":"(Udløbet)",
	"uploadImage":"Upload billede",
    "uploadImageInfo":"Eller slip din billedfil her for at fjerne vandmærket!",

    "watermark_beyond_pixel_3":"The selected image exceeds <span>%s&times;%s resolution</span>, please upgrade your plan first.",
    "watermark_beyond_size_3":"The selected image exceeds <span>%sMB</span>, please upgrade your plan first.",
    "no_user_login":"New users who login can gain THREE HD original image downloading benefits.<span class=\"loginMaskbtn\">Login immediately>></span>",
    "Unlimited":"Ubegrænset",
    "watermark_beyond_pixel_3":"Det valgte billede overstiger <span>%s&times;%s opløsning</span>. Opgrader venligst din plan først.",
    "watermark_beyond_size_3":"Det valgte billede overstiger <span>%sMB</span>. Opgrader venligst din plan først.",
    "no_user_login":"Nye brugere, der logger ind, kan få TO fordele ved at downloade originale HD-billeder.<span class=\"loginMaskbtn\">Log ind med det samme>></span>",
    "Upgrade":"Opgrader",
    "Loading":"Indlæser…",
    "SelectAll":"Vælg alle",
    "Open":"Åben",
    "Delete":"Slet",
    "Clear":"Ryd ugyldig",
    "noHistory":"Ingen historie",
    "Close":"Tæt",
    "buyUserInfo":"tillykke! Du har opgraderet med succes. Venligst vend tilbage til startsiden og brug dette produkt.",
    "buyNoUserInfo":"Tillykke! Du har opgraderet med succes. Fordelene er bundet til den e-mailadresse, du efterlod under opgraderingen. Brug venligst den konto, der er registreret eller knyttet til e-mail-adressen for at <span class=\"loginMaskbtn\">login for at bruge fordele</span>. Hvis du ikke har registreret eller knyttet en konto til e-mail-adressen, skal du <span class=\"registerMaskbtn\">brug e-mailadressen til at registrere en konto</span> eller linke andre konti til denne e- mailadresse for at bruge fordele.",
    "GetStarted":"Kom igang",
    "AccessTo":"Adgang til:",
    "imagesOfwatermarkremoval":"billeder af fjernelse af vandmærke",
    "upTo":"Op til",
    "perImage":"per billede",
    "Support":"Support",
    "resolution":"løsning",
    "PrepaidPackage":"Forudbetalt pakke",
    "PayasYouGo":"Betal når du går",
    "TaxIncl":"Inkl. skat.",
    "Checkout":"Checkout",
    "imagesDay":"billeder/dag",
    "imagesMonthly":"billeder/månedlig",
    "image":"billede",
    "images":"billeder",
    "imageSize":"billedestørrelse",
    "buyInfo1":"Tredjeparts <span>enhancer</span> integrationer",
    "buyInfo2":"Redigeringshistorikken er gyldig i 7 dage",
    "buyInfo3":"Prioritetsbehandling",
    "buyInfo4":"7x24 kundesupport",
    "buyInfo5":"Udløb efter 24 timer",
    "buyInfo6":"Intet abonnement. Ingen automatisk fornyelse!",
    "buyInfo7":"Tilgængelig til brug når som helst for evigt",
    "dayPlan":"1-dags plan",
    "Lifetime":"Livstid",
    "note":"<span>Bemærk</span>: Bemærk venligst, at den købte plan er knyttet til den e-mailadresse, der blev angivet under kassen. For at bruge planen med succes skal du registrere eller logge ind med den samme e-mailadresse."
}